import React from 'react'
import './TextInput.css'

class RFTextInput extends React.Component {
  render () {
    let {input, meta, type, placeholder, readOnly, inputClassName} = this.props
    let {touched, error} = meta
    return (
      <div className={this._wrapperClassName()}>
        <input
          {...input}
          type={type}
          className={`${inputClassName} form-control`}
          placeholder={placeholder}
          onChange={this._onChange}
          readOnly={readOnly}
        />
        {!readOnly && touched && error && <span className={`form-control-feedback glyphicon glyphicon-remove`} />}
        {!readOnly && touched && !error && <span className={`form-control-feedback glyphicon glyphicon-ok`} />}
        {!readOnly && touched && error && <span className='form-feedback'>{error}</span>}
      </div>
    )
  }

  _wrapperClassName = () => {
    const {meta: {touched, error}, readOnly} = this.props
    return `fields-text-field__wrapper ${(!readOnly && touched) ? (error ? 'has-feedback has-error' : 'has-feedback has-success') : ''}`
  }

  _onChange = (e) => {
    const {input: {onChange}} = this.props
    onChange(e)
  }
}

RFTextInput.defaultProps = {
  readOnly: false
}

export {RFTextInput}



// WEBPACK FOOTER //
// app/javascript/components/fields/TextInput/TextInput.js